import { isSingularPluralMatch, fieldNameImpliesEntity, fieldNameIsEntityIdReference } from './fieldNameMatch.js'

export const fieldHasNoMatchingEntityField = (entityId, field, schemas) => {
  if (field?.computed) {
    return false
  }
  if (!entityId || !schemas) {
    return false
  }

  const fieldName = field?.name
  const entity = schemas.find((s) => s.id === entityId) ?? { fields: [] }

  if ((entity.fields || []).some((f) => isSingularPluralMatch(f.name, fieldName))) {
    return false
  }

  const referencedEntities = (entity.fields || [])
    .filter((f) => f.relatedEntityId)
    .map((f) => schemas.find((s) => s.id === f.relatedEntityId))
    .filter(Boolean)

  const existsOnReferencedEntity = referencedEntities.some((refEntity) =>
    (refEntity.fields || []).some((f) => f.name === fieldName || isSingularPluralMatch(f.name, fieldName))
  )
  if (existsOnReferencedEntity) {
    return false
  }

  const parentEntities = schemas.filter((s) =>
    (s.fields || []).some((f) => f.relatedEntityId === entityId)
  )
  if (parentEntities.some((parent) => fieldNameIsEntityIdReference(fieldName, parent.name))) {
    return false
  }

  return ![entity, ...referencedEntities].some((e) => fieldNameImpliesEntity(fieldName, e.name))
}

export const walkCardFields = (rootEntityId, fields, schemas, visit, parentPath = []) => {
  for (const field of fields || []) {
    const path = [...parentPath, field?.name]
    visit({ field, parentEntityId: rootEntityId, path })

    if (field?.relatedEntityId && Array.isArray(field.fields) && field.fields.length > 0) {
      walkCardFields(field.relatedEntityId, field.fields, schemas, visit, path)
    }
  }
}
